/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useRef } from "react"

import { Link, graphql, useStaticQuery } from "gatsby"

import styled from "styled-components"

const Container = styled.div`
  position: relative;
  height: 50vh;
  max-height: 300px;
  width: 100vw;
  overflow: hidden;
  background-color: ${props =>
    props.overrideBackgroundColor
      ? props.overrideBackgroundColor
      : props.backgroundColor
      ? props.backgroundColor
      : "#eeede9"};
  bottom: 0;
  z-index: 0;
  opacity: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: 568px) and (max-width: 992px) {
    min-height: 400px;
    max-height: none;
  }

  @media (min-width: 576px) {
    max-height: none;
    height: 33.3vh;
  }
`
const Top = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: center;
  padding: 4rem 1.5rem 0 1.5rem;

  > div:nth-child(2) {
    margin-top: 3rem;
  }

  > a {
    width: 100%;
    box-sizing: border-box;
    max-width: 420px;
  }

  .button {
    width: 100% !important;
    padding: 0;
    color: ${props =>
      props.overrideTextColor
        ? props.overrideTextColor
        : props.textColor
        ? props.textColor
        : "#272727"};
    border: 1px solid
      ${props =>
        props.overrideTextColor
          ? props.overrideTextColor
          : props.textColor
          ? props.textColor
          : "#272727"};
  }

  .button:hover {
    color: ${props =>
      props.overrideTextColor
        ? props.overrideTextColor
        : props.textColor
        ? props.textColor
        : "#272727"};
    border: 1px solid
      ${props =>
        props.overrideTextColor
          ? props.overrideTextColor
          : props.textColor
          ? props.textColor
          : "#272727"};
    background-color: transparent;
    opacity: 0.5;
  }

  @media (min-width: 992px) {
    justify-content: space-between;
    flex-direction: row;
    padding: 4rem 3.625rem 0 3.625rem;

    div:nth-child(2) {
      margin-top: 0;
    }
  }
`

const Bottom = styled.div`
  padding: 0 0 1.5rem 1.5rem;
  box-sizing: border-box;
  width: 100%;
  color: ${props =>
    props.overrideTextColor
      ? props.overrideTextColor
      : props.textColor
      ? props.textColor
      : "#272727"};

  a {
    color: ${props =>
      props.overrideTextColor
        ? props.overrideTextColor
        : props.textColor
        ? props.textColor
        : "#272727"} !important;
  }

  .copyright {
    // display: flex;
  }

  .copyright  a {
    // margin: 0 5px;
    text-decoration: none !important;
  }

  @media (min-width: 992px) {
    padding: 0 0 3.625rem 3.625rem;
  }
`
const Socials = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  > a {
    opacity: 1;
    transition: opacity 0.7s;
  }

  > div {
    height: 1.5rem;
    width: 1.5rem;
    padding-left: 0;
  }

  svg {
    height: 25px !important;
    width: auto;
  }

  path {
    fill: ${props =>
      props.overrideTextColor
        ? props.overrideTextColor
        : props.textColor
        ? props.textColor
        : "#272727"};
  }

  @media (min-width: 992px) {
    justify-content: flex-end;

    > a {
      margin: 0 1.25rem;
    }

    > div {
      height: 1.5rem;
      width: 1.5rem;
    }
  }

  > a:hover {
    opacity: 0.5;
    transition: opacity 0.3s;
  }
`

const Button = styled(Link)`
  text-decoration: none;
`

const LinkWrapper = styled.div`
  margin-top: 40px;
`


const Footer = props => {
  let socialLinksQuery = useStaticQuery(graphql`
    {
      craft {
        entries(section: ["Socials"]) {
          ... on Craft_socials_socials_Entry {
            socials {
              instagram
              facebook
              twitter
              youtube
              spotify
              bandcamp
              appleMusic
            }
          }
        }
      }
    }
  `)

  let socials = socialLinksQuery.craft.entries[0].socials[0]

  // useEffect(() => {
  //   let scriptTag = document.createElement("script")
  //   scriptTag.setAttribute("type", "text/javascript")
  //   scriptTag.src = `https://app.mailjet.com/statics/js/widget.modal.js?cachebuster=${new Date().getTime()}`

  //   document.querySelector("head").appendChild(scriptTag)

  //   return () => {
  //     document.querySelector("head").removeChild(scriptTag)
  //   }
  // }, [])

  return (
    <>
      <Container
        className="footer-container"
        backgroundColor={props.backgroundColor}
        textColor={props.textColor}
        overrideBackgroundColor={props.overrideBackgroundColor}
      >
        <Top
          textColor={props.textColor}
          overrideTextColor={props.overrideTextColor}
        >
          {/* <div>
            <data
              id="mj-w-res-data"
              data-token="9cae3a518705d2318b3b8d5a6c92f8e3"
              className="mj-w-data"
              data-apikey="4UYd"
              data-w-id="qe9"
              data-lang="en_US"
              data-base="https://app.mailjet.com"
              data-width="640"
              data-height="328"
              data-statics="statics"
            ></data>

            <div
              class="mj-w-button mj-w-btn button"
              data-token="9cae3a518705d2318b3b8d5a6c92f8e3"
            >
              <div>
                <div>
                  <div
                    data-token="9cae3a518705d2318b3b8d5a6c92f8e3"
                    class="mj-w-button-content"
                  >
                    Subscribe to the Jónsi mailing list
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* <Button className="button" to="/subscribe">
            Subscribe to the HB+F mailing list
          </Button> */}

          <Socials
            textColor={props.textColor}
            overrideTextColor={props.overrideTextColor}
          >
            {/* <a href={socials.instagram} target="_blank">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23.544"
                  height="23.44"
                  viewBox="0 0 23.544 23.44"
                >
                  <path
                    class="a"
                    d="M742.2,560.357c3.144,0,3.516.012,4.756.068a6.534,6.534,0,0,1,2.186.4,3.911,3.911,0,0,1,2.237,2.226,6.452,6.452,0,0,1,.406,2.175c.056,1.237.068,1.607.068,4.736s-.012,3.5-.068,4.734a6.459,6.459,0,0,1-.406,2.176,3.9,3.9,0,0,1-2.235,2.225,6.534,6.534,0,0,1-2.186.4c-1.241.056-1.612.066-4.757.066s-3.512-.014-4.755-.074a6.54,6.54,0,0,1-2.183-.4,3.909,3.909,0,0,1-2.237-2.226,6.452,6.452,0,0,1-.406-2.176c-.056-1.234-.069-1.606-.069-4.734s.013-3.5.069-4.736a6.446,6.446,0,0,1,.406-2.175,3.909,3.909,0,0,1,2.237-2.226,6.539,6.539,0,0,1,2.183-.394c1.243-.06,1.616-.068,4.754-.068m0-2.112c-3.2,0-3.6.013-4.854.07a8.7,8.7,0,0,0-2.857.545,6.021,6.021,0,0,0-3.439,3.427,8.646,8.646,0,0,0-.547,2.844c-.056,1.249-.07,1.648-.07,4.831s.014,3.58.07,4.83a8.609,8.609,0,0,0,.547,2.849,5.995,5.995,0,0,0,3.444,3.427,8.66,8.66,0,0,0,2.858.545c1.255.057,1.658.07,4.853.07s3.6-.013,4.854-.07a8.665,8.665,0,0,0,2.857-.545,6,6,0,0,0,3.444-3.427,8.6,8.6,0,0,0,.548-2.843c.055-1.251.07-1.649.07-4.83s-.016-3.582-.07-4.83a8.606,8.606,0,0,0-.548-2.844,6,6,0,0,0-3.443-3.433,8.707,8.707,0,0,0-2.858-.546c-1.256-.057-1.657-.07-4.854-.07"
                    transform="translate(-730.434 -558.244)"
                  />
                  <path
                    class="a"
                    d="M741.685,563.452a5.99,5.99,0,1,0,6.045,5.992,6.017,6.017,0,0,0-6.045-5.992m0,9.879a3.888,3.888,0,1,1,3.923-3.887h0a3.906,3.906,0,0,1-3.923,3.887"
                    transform="translate(-729.914 -557.724)"
                  />
                  <path
                    class="a"
                    d="M748.39,563.362a1.412,1.412,0,0,1-2.825,0h0a1.411,1.411,0,0,1,1.411-1.412h0a1.411,1.411,0,0,1,1.411,1.411h0"
                    transform="translate(-728.922 -557.896)"
                  />
                </svg>
              </div>
            </a> */}
            {/* <a href={socials.facebook} target="_blank">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="23.855"
                  viewBox="0 0 24 23.855"
                >
                  <path
                    class="a"
                    d="M24,12A12,12,0,1,0,10.125,23.855V15.469H7.078V12h3.047V9.356c0-3.007,1.791-4.669,4.533-4.669a18.456,18.456,0,0,1,2.686.234V7.875H15.83A1.734,1.734,0,0,0,13.875,9.75V12H17.2l-.532,3.469h-2.8v8.386A12,12,0,0,0,24,12Z"
                  />
                </svg>
              </div>
            </a>
            <a href={socials.twitter} target="_blank">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28.008"
                  height="22.647"
                  viewBox="0 0 28.008 22.647"
                >
                  <path
                    class="a"
                    d="M831.579,582.255a16.2,16.2,0,0,0,16.353-16.267c0-.247,0-.5-.016-.739a11.649,11.649,0,0,0,2.864-2.96,11.542,11.542,0,0,1-3.3.9,5.748,5.748,0,0,0,2.528-3.164,11.557,11.557,0,0,1-3.649,1.388,5.74,5.74,0,0,0-9.789,5.214,16.35,16.35,0,0,1-11.848-5.973,5.7,5.7,0,0,0,1.778,7.632,5.775,5.775,0,0,1-2.6-.718v.07a5.726,5.726,0,0,0,4.612,5.6,5.731,5.731,0,0,1-1.512.207,5.856,5.856,0,0,1-1.08-.1,5.756,5.756,0,0,0,5.365,3.971,11.686,11.686,0,0,1-8.51,2.367,16.349,16.349,0,0,0,8.813,2.564"
                    transform="translate(-822.771 -559.608)"
                  />
                </svg>
              </div>
            </a>
            <a href={socials.youtube} target="_blank">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32.327"
                  height="22.647"
                  viewBox="0 0 32.327 22.647"
                >
                  <path
                    class="a"
                    d="M899.484,563.336a4.052,4.052,0,0,0-2.858-2.861C894.106,559.8,884,559.8,884,559.8s-10.109,0-12.629.677a4.048,4.048,0,0,0-2.857,2.861,45.13,45.13,0,0,0,0,15.572,4.047,4.047,0,0,0,2.857,2.861c2.52.677,12.629.677,12.629.677s10.109,0,12.629-.677a4.046,4.046,0,0,0,2.856-2.861,45.158,45.158,0,0,0,0-15.572ZM880.691,575.9v-9.56l8.45,4.78Z"
                    transform="translate(-867.834 -559.798)"
                  />
                </svg>
              </div>
            </a>
            <a href={socials.spotify} target="_blank">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23.919"
                  height="23.906"
                  viewBox="0 0 23.919 23.906"
                >
                  <path
                    class="a"
                    d="M248.429,995.55a11.829,11.829,0,0,1,4.294,4.294,11.618,11.618,0,0,1,1.627,6.045,11.976,11.976,0,0,1-1.627,6.045,11.94,11.94,0,1,1-4.294-16.384Zm1.874,9.111a1.1,1.1,0,0,0,.7-.506,1.03,1.03,0,0,0,.123-.848,1.169,1.169,0,0,0-.506-.7,16.39,16.39,0,0,0-5.115-1.86,23.969,23.969,0,0,0-5.634-.493,20.669,20.669,0,0,0-4.951.738,1.087,1.087,0,0,0-.656.547,1.134,1.134,0,0,0-.1.862,1.037,1.037,0,0,0,.533.67,1.06,1.06,0,0,0,.848.082,17.1,17.1,0,0,1,4.4-.656,21.521,21.521,0,0,1,5.005.41,14.288,14.288,0,0,1,4.513,1.614A1.049,1.049,0,0,0,250.3,1004.661Zm-.848,2.557a.988.988,0,0,0-.424-.588,14.661,14.661,0,0,0-4.144-1.7,18.7,18.7,0,0,0-4.732-.547,17.015,17.015,0,0,0-4.581.656.872.872,0,0,0-.533.451.951.951,0,0,0,.383,1.272.86.86,0,0,0,.7.082,14.45,14.45,0,0,1,4.048-.6,16.428,16.428,0,0,1,4.226.493,12.805,12.805,0,0,1,3.651,1.5.918.918,0,0,0,.711.1.883.883,0,0,0,.574-.424A.833.833,0,0,0,249.455,1007.218Zm-1.573,3.98a.71.71,0,0,0,.082-.574.787.787,0,0,0-.328-.465q-4.759-2.9-11.624-1.34a.771.771,0,0,0-.465.342.745.745,0,0,0,.233,1.026.674.674,0,0,0,.561.082q6.263-1.423,10.5,1.176a.83.83,0,0,0,.574.069.7.7,0,0,0,.465-.342Z"
                    transform="translate(-230.432 -993.936)"
                  />
                </svg>
              </div>
            </a>
            <a href={socials.bandcamp} target="_blank">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23.905"
                  height="23.905"
                  viewBox="0 0 23.905 23.905"
                >
                  <path
                    class="a"
                    d="M11.953,0A11.953,11.953,0,1,0,23.905,11.953,11.952,11.952,0,0,0,11.953,0Zm2.325,15.711H5.556L9.628,8.194h8.722Z"
                  />
                </svg>
              </div>
            </a>
            <a href={socials.appleMusic} target="_blank">
              <div>
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  x="0px"
                  y="0px"
                  width="28.188px"
                  height="28.195px"
                  viewBox="0 0 28.188 28.195"
                  enable-background="new 0 0 28.188 28.195"
                >
                  <path d="M28.187,7.195c-0.001-0.867-0.076-1.728-0.282-2.574c-0.372-1.536-1.247-2.713-2.561-3.573 C24.67,0.607,23.93,0.335,23.14,0.193c-0.608-0.109-1.221-0.159-1.838-0.177c-0.048-0.002-0.098-0.009-0.146-0.014H7.032 c-0.178,0.01-0.356,0.02-0.534,0.03c-0.878,0.05-1.75,0.146-2.575,0.472C2.351,1.126,1.219,2.21,0.555,3.768 C0.33,4.296,0.212,4.856,0.129,5.423C0.062,5.883,0.024,6.345,0.011,6.81C0.01,6.846,0.002,6.882-0.001,6.918v14.359 c0.01,0.166,0.019,0.332,0.03,0.498c0.059,0.957,0.181,1.908,0.584,2.787c0.764,1.668,2.041,2.764,3.799,3.291 c0.495,0.149,1.005,0.22,1.519,0.268c0.651,0.062,1.304,0.072,1.957,0.072c4.319,0,8.638,0,12.957-0.002 c0.617,0,1.231-0.039,1.844-0.116c0.967-0.124,1.876-0.412,2.697-0.952c0.988-0.65,1.729-1.512,2.208-2.594 c0.219-0.495,0.344-1.021,0.434-1.555c0.134-0.793,0.163-1.595,0.162-2.397C28.188,16.116,28.191,11.656,28.187,7.195 M20.642,11.882c0,2.237,0.001,4.474-0.001,6.71c0,0.49-0.067,0.971-0.285,1.417c-0.339,0.694-0.894,1.13-1.63,1.339 c-0.41,0.117-0.829,0.184-1.256,0.203c-1.118,0.053-2.084-0.705-2.284-1.804c-0.166-0.907,0.268-1.907,1.221-2.374 c0.38-0.188,0.786-0.293,1.196-0.381c0.444-0.096,0.89-0.18,1.332-0.282c0.322-0.074,0.537-0.271,0.6-0.606 c0.015-0.074,0.021-0.151,0.021-0.227c0.001-2.132,0.001-4.263-0.001-6.394c0-0.073-0.012-0.147-0.03-0.217 c-0.046-0.177-0.175-0.285-0.357-0.275c-0.188,0.011-0.373,0.041-0.558,0.078c-0.893,0.176-1.785,0.357-2.677,0.537 c-0.911,0.183-1.822,0.368-2.734,0.552c-0.538,0.109-1.076,0.217-1.614,0.326c-0.019,0.004-0.038,0.01-0.056,0.015 c-0.325,0.09-0.443,0.239-0.458,0.575c-0.002,0.051-0.001,0.102-0.001,0.154c-0.001,3.056,0,6.113-0.002,9.168 c0,0.494-0.055,0.982-0.253,1.441c-0.327,0.754-0.905,1.223-1.685,1.45c-0.412,0.119-0.835,0.187-1.263,0.202 c-1.126,0.042-2.061-0.706-2.254-1.814c-0.167-0.955,0.27-1.98,1.354-2.439c0.419-0.176,0.859-0.273,1.301-0.365 c0.337-0.071,0.675-0.135,1.011-0.207c0.449-0.098,0.684-0.38,0.703-0.839c0.002-0.06,0.001-0.117,0.001-0.177 c0-3.477,0-6.955,0.002-10.432c0-0.145,0.015-0.294,0.049-0.435c0.082-0.335,0.321-0.526,0.641-0.609 c0.3-0.078,0.605-0.132,0.909-0.194c0.861-0.174,1.722-0.347,2.583-0.52c0.89-0.18,1.779-0.359,2.669-0.539 c0.786-0.159,1.572-0.32,2.36-0.475c0.258-0.051,0.52-0.103,0.78-0.124c0.364-0.029,0.614,0.2,0.651,0.566 c0.009,0.087,0.014,0.175,0.014,0.263C20.643,7.394,20.643,9.638,20.642,11.882L20.642,11.882z" />
                </svg>
              </div>
            </a> */}
          </Socials>
        </Top>
        <Bottom
          textColor={props.textColor}
          overrideTextColor={props.overrideTextColor}
        >
          <span className="copyright">
            {/* © HB+F {new Date().getFullYear()}.{" "} */}
            {/* <a href={socials.instagram} target="_blank" className="insta-icon">
              <div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23.544"
                  height="15"
                  viewBox="0 0 23.544 23.44"
                >
                  <path
                    class="a"
                    d="M742.2,560.357c3.144,0,3.516.012,4.756.068a6.534,6.534,0,0,1,2.186.4,3.911,3.911,0,0,1,2.237,2.226,6.452,6.452,0,0,1,.406,2.175c.056,1.237.068,1.607.068,4.736s-.012,3.5-.068,4.734a6.459,6.459,0,0,1-.406,2.176,3.9,3.9,0,0,1-2.235,2.225,6.534,6.534,0,0,1-2.186.4c-1.241.056-1.612.066-4.757.066s-3.512-.014-4.755-.074a6.54,6.54,0,0,1-2.183-.4,3.909,3.909,0,0,1-2.237-2.226,6.452,6.452,0,0,1-.406-2.176c-.056-1.234-.069-1.606-.069-4.734s.013-3.5.069-4.736a6.446,6.446,0,0,1,.406-2.175,3.909,3.909,0,0,1,2.237-2.226,6.539,6.539,0,0,1,2.183-.394c1.243-.06,1.616-.068,4.754-.068m0-2.112c-3.2,0-3.6.013-4.854.07a8.7,8.7,0,0,0-2.857.545,6.021,6.021,0,0,0-3.439,3.427,8.646,8.646,0,0,0-.547,2.844c-.056,1.249-.07,1.648-.07,4.831s.014,3.58.07,4.83a8.609,8.609,0,0,0,.547,2.849,5.995,5.995,0,0,0,3.444,3.427,8.66,8.66,0,0,0,2.858.545c1.255.057,1.658.07,4.853.07s3.6-.013,4.854-.07a8.665,8.665,0,0,0,2.857-.545,6,6,0,0,0,3.444-3.427,8.6,8.6,0,0,0,.548-2.843c.055-1.251.07-1.649.07-4.83s-.016-3.582-.07-4.83a8.606,8.606,0,0,0-.548-2.844,6,6,0,0,0-3.443-3.433,8.707,8.707,0,0,0-2.858-.546c-1.256-.057-1.657-.07-4.854-.07"
                    transform="translate(-730.434 -558.244)"
                  />
                  <path
                    class="a"
                    d="M741.685,563.452a5.99,5.99,0,1,0,6.045,5.992,6.017,6.017,0,0,0-6.045-5.992m0,9.879a3.888,3.888,0,1,1,3.923-3.887h0a3.906,3.906,0,0,1-3.923,3.887"
                    transform="translate(-729.914 -557.724)"
                  />
                  <path
                    class="a"
                    d="M748.39,563.362a1.412,1.412,0,0,1-2.825,0h0a1.411,1.411,0,0,1,1.411-1.412h0a1.411,1.411,0,0,1,1.411,1.411h0"
                    transform="translate(-728.922 -557.896)"
                  />
                </svg>
              </div>
            </a> */}
            <h3>
            HB+F <br/>
            58 Old Compton Street <br/>
            London W1D 4UF <br/>
            <a href="mailto:studio@hbandf.co.uk">studio@hbandf.co.uk</a>
            </h3>
            {" "}
            <LinkWrapper>          
              <Link to="/terms-and-conditions">Terms & Conditions</Link>
            </LinkWrapper>  
          </span>
        </Bottom>
      </Container>
    </>
  )
}

export default Footer
